export default __webpack_public_path__ + "images/icon-data-toggle.svg";